import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/api";
import Layout from "../components/Layout";

export default function SetupQuestions() {
  const { id: interviewId } = useParams(); // 🔥 FIXED HERE
  const navigate = useNavigate();

  const [rounds, setRounds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const res = await api.get(`/interviews/${interviewId}/rounds`);
        setRounds(res.data.rounds || []);
      } catch (err) {
        console.error("Failed to fetch rounds:", err);
        setError("Failed to load rounds. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchRounds();
  }, [interviewId]);

  if (loading) {
    return (
      <Layout>
        <p className="text-gray-600">Loading rounds…</p>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <p className="text-red-500">{error}</p>
      </Layout>
    );
  }

  return (
    <Layout>
      <h2 className="text-2xl font-bold mb-4">Step 2: Setup Questions</h2>

      {rounds.length === 0 ? (
        <EmptyState interviewId={interviewId} />
      ) : (
        <div>
          <p className="mb-4 text-gray-700">
            You have {rounds.length} round{rounds.length > 1 ? "s" : ""} configured.
          </p>
          <ul className="space-y-3">
            {rounds.map((round) => (
              <li
                key={round.id}
                className="p-4 border rounded-lg flex justify-between items-center hover:shadow"
              >
                <span className="font-medium">{round.name}</span>
                <button
                  onClick={() =>
                    navigate(`/interviews/${interviewId}/rounds/${round.id}/questions`)
                  }
                  className="text-blue-600 hover:underline"
                >
                  Manage Questions →
                </button>
              </li>
            ))}
          </ul>

          <button
            onClick={() => navigate(`/interviews/${interviewId}/rounds/new`)}
            className="mt-6 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition"
          >
            ➕ Add Another Round
          </button>
        </div>
      )}
    </Layout>
  );
}

function EmptyState({ interviewId }) {
  const navigate = useNavigate();

  return (
    <div className="text-center py-10">
      <h3 className="text-2xl font-semibold mb-2">No Rounds Found</h3>
      <p className="text-gray-600 mb-4">
        You haven’t added any rounds to this interview yet. Add your first round to begin adding
        questions.
      </p>
      <button
        onClick={() => navigate(`/interviews/${interviewId}/rounds/new`)}
        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition"
      >
        ➕ Add First Round
      </button>
    </div>
  );
}